/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

export interface FolderShareProps extends IconProps {
  folderColor?: string;
};

/*
 * Defines the Design Language System (DLS) FolderShared Icon component.
 */
export const FolderShared = ({color, size, folderColor, ...props}: FolderShareProps) => {
  const {iconSize = 24, iconColor = dlsColor('grey1')} = useIconDLS({color, size});
  return (
    <ThemeIconProvider name='FolderShared' size={size} color={color} folderColor={folderColor} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        {folderColor && (<rect x='4' y='7' width='6' height='12' fill={folderColor} rx='1' ry='1'/>)}
        <path clipRule='evenodd' d='M20.5 8c-.189 0-.37-.035-.536-.098l-2.46 1.757 2.198 1.57a1.5 1.5 0 1 1-.622.785l-2.34-1.671A1.499 1.499 0 0 1 14 9.5a1.5 1.5 0 0 1 2.868-.616l2.32-1.657A1.5 1.5 0 1 1 20.5 8zM8.586 8l2 2h2.41V9H11L9 7H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1.98h-1V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.586z' fill={iconColor} />
      </svg>
    )} />
  );
};

export default FolderShared;
